/* eslint jsx-a11y/anchor-is-valid: 0 */

import React from "react";
import PropTypes from "prop-types";
import {
  Card,
  CardHeader,
  CardBody,
  ListGroup,
  ListGroupItem,
  Button
} from "shards-react";
import { connect } from "react-redux";
import CheckGrammarButton from "../button/CheckGrammarButton";

const SidebarActions = props => (
  <Card small className="mb-3">
    <CardHeader className="border-bottom">
      <h6 className="m-0">{props.title}</h6>
    </CardHeader>

    <CardBody className="p-0">
      <ListGroup flush>
        <ListGroupItem className="p-3">
          <span className="d-flex mb-2">
            <i className="material-icons mr-1">flag</i>
            <strong className="mr-1">Status:</strong> {props.currentStatus}{" "}
          </span>
        </ListGroupItem>
        <ListGroupItem className="d-flex px-3 border-0">
          <CheckGrammarButton onClick={props.handleCheckGrammarClick} />
          <Button outline theme="accent" onClick={props.saveDraft} size="sm">
            <i className="material-icons">save</i>{" "}
            {props.save_button || `Save ${props.currentStatus}`}
          </Button>
          {/* {props.currentStatus !== "published" ? (
            <Button outline theme="danger" size="sm" className="ml-auto">
              <i className="material-icons">delete_forever</i> Delete
            </Button>
          ) : (
            ""
          )} */}
          {props.currentStatus !== "published" &&
          props.currentStatus !== "publish" ? (
            <Button
              theme="accent"
              onClick={() => props.saveDraft("publish")}
              size="sm"
              className="ml-auto"
            >
              <i className="material-icons">file_copy</i> Send to ready passages
            </Button>
          ) : (
            ""
          )}
        </ListGroupItem>
      </ListGroup>
    </CardBody>
  </Card>
);

SidebarActions.propTypes = {
  /**
   * The component's title.
   */
  title: PropTypes.string
};

SidebarActions.defaultProps = {
  title: "Actions"
};

const mapStateToProps = state => {
  return {
    currentStatus: state.currentStatus
  };
};

export default connect(mapStateToProps)(SidebarActions);
